import {Brick, registerBrick, tagToString} from 'olympe';

export default class IsInQueryResult extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {QueryResult} queryResult
     * @param {CloudObject} object
     * @param {function(boolean)} setResult
     */
    update($, [queryResult, object], [setResult]) {
        setResult(queryResult.has(tagToString(object)));
    }
}

registerBrick('01898f05abcb0ec4ea19', IsInQueryResult);
